import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators, } from "@angular/forms";
import { IDatepickerSchema, ToastService } from "maps-angular-components";
import { BehaviorSubject, Subscription } from "rxjs";
import { map } from "rxjs/operators";

import { HttpErrorResponse } from "@angular/common/http";
import { FuncaoApi } from "src/app/funcao/api/funcao.api";
import { Funcao, FuncaoDTO } from "src/app/funcao/models/funcao";
import { ParametroTipo } from "../../funcao/models/parametro-funcao";
import { DatepickerDayComponent } from "../../shared/components/datepicker/datepicker-day/datepicker-day.component";
import { Regra } from "../regra";
import { RegraService } from "../regra.service";

@Component({
  selector: "cadastro-regra",
  templateUrl: "./cadastro-regra.component.html",
  styleUrls: [
    "./cadastro-regra.component.scss",
    "../../shared/form-component.css",
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CadastroRegraComponent implements OnInit, OnDestroy {
  private readonly subscriptions = new Subscription();

  nome: string;

  @ViewChild("cadastroRegraDataInicioVigencia", {static: false})
  cadastroRegraDataInicioVigencia: DatepickerDayComponent;
  @ViewChild("cadastroRegraDataFimVigencia", {static: false})
  cadastroRegraDataFimVigencia: DatepickerDayComponent;

  @Input() composta = false;

  @Input() regra: Regra;

  @Input() functionEnabled = true;

  @Output()
  onFormChange: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();

  @Output()
  closeDialog: EventEmitter<any> = new EventEmitter<any>();

  form: FormGroup;

  @Input()
  isConsulta = false;

  _isDiolog = false;

  funcoes: Funcao[] = [];
  filteredFuncoes$: BehaviorSubject<Funcao[]> = new BehaviorSubject<Funcao[]>([]);

  filteredFuncoes: Funcao[] = [];

  funcaoSelecionada: Funcao;

  categorias: string[];

  idRegra: string;

  parametrosRegra;

  deveCriarRegra = true;

  private estadoParametros;

  public dataInicioSchema: IDatepickerSchema;

  public dataFimSchema: IDatepickerSchema;

  @ViewChild("formDirective") formDirective;

  get canExplosao(): boolean {
    return this.form.controls.funcoes.value?.explosao === 'SIM';
  }

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly regraService: RegraService,
    private readonly funcaoService: FuncaoApi,
    private readonly toastService: ToastService
  ) {
  }

  async ngOnInit() {
    this.createForm();

    this.subscriptions.add(
      this.funcaoService.buscarCategorias().subscribe((categorias) => {
        this.categorias = categorias;
      })
    );

    if (!this.composta) {
      await this.buscarFuncoes("");
    } else if (!this.regra) {
      await this.buscarFuncaoComposta();
    }

    this.filteredFuncoes$.subscribe(values => {
      this.filteredFuncoes = values;
    })
  }

  markAsPending(): void {
    Object.keys(this.form.controls).forEach((field) => {
      const control = this.form.get(field);
      if (control instanceof FormControl) {
        control.markAsPending();
      }
    });
  }

  limparForm() {
    this.createForm();
    this.form.reset();
    this.formDirective.resetForm();
    this.funcaoSelecionada = null;
    this.markAsPending();
    if (!this.composta) {
      this.buscarFuncoes("");
    } else {
      this.buscarFuncaoComposta();
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  private formGroupIsEmpty(group) {
    let empty = true;
    Object.keys(group.controls).forEach((control) => {
      if (group.get(control).value !== null) empty = false;
    });
    return empty;
  }

  private createForm() {
    this.form = this.formBuilder.group({
      nome: new FormControl(
        {value: null, disabled: this.isConsulta},
        Validators.required
      ),
      categoria: new FormControl({
        value: "",
        disabled: this.isConsulta || !this.functionEnabled,
      }),
      funcoes: new FormControl(
        {value: "", disabled: this.isConsulta || !this.functionEnabled},
        Validators.required
      ),
      dataInicioVigencia: new FormControl(
        {value: "", disabled: this.isConsulta},
        Validators.required
      ),
      dataFimVigencia: new FormControl({
        value: "",
        disabled: this.isConsulta,
      }),
      utilizaCarteiraExplodida: new FormControl({value: null, disabled: this.isConsulta}),
      parametros: new FormGroup({}),
    });

    this.dataInicioSchema = {
      label: "Data início vigência",
      placeholder: "Selecione uma data",
      formGroup: this.form,
      formControlName: "dataInicioVigencia",
      required: true,
      panelClass: 'w-100',
      value: this.regra ? new Date(this.regra['inicioVigencia']) : null
    };

    this.dataFimSchema = {
      label: "Data fim vigência",
      placeholder: "Selecione uma data",
      formGroup: this.form,
      formControlName: "dataFimVigencia",
      required: true,
      panelClass: 'w-100',
      value: this.regra ? new Date(this.regra['fimVigencia']) : new Date("2999-12-31"),
    };

    this.form.valueChanges
      .pipe(map(value => ({ ...value, funcoes: value.funcoes?.nome})))
      .subscribe((values) => {
        this.onFormChange.emit(this.form);
      });

    if (this.regra) {
      this.form.get('nome').setValue(this.regra['nome']);
      this.parametrosRegra = this.regra['parametros'];
      this.popularRegra(this.regra);
    }

    const categoria = this.form.get("categoria") as FormControl;
    categoria.patchValue("");
    categoria.valueChanges.subscribe((valor) => {
      this.form.get("funcoes").reset();
      this.buscarFuncoes(valor);
    });

    this.form.get("funcoes").valueChanges.subscribe(value => {
      if (value == null || value == undefined || value instanceof Object) return;
        this._filtrar(value);
    })
  }

  selecionarFuncao(nomeFuncao: any) {
    const _funcao = this.funcoes.find(f => f.nome == nomeFuncao.nome);

    if (this.funcaoSelecionada && this.funcaoSelecionada !== _funcao) {
      this.funcaoSelecionada = _funcao;

      this.parametrosRegra = [];

      this.form.setControl("parametros", new FormGroup({}));
    } else {
      this.funcaoSelecionada = _funcao;
    }

    this.validarObrigatoriedade();
  }

  private validarObrigatoriedade() {
    this.form.get("parametros").valueChanges.subscribe((value) => {

      if (JSON.stringify(value) != JSON.stringify(this.estadoParametros)) {
        this.estadoParametros = value;
      } else {
        return;
      }

      if (this.funcaoSelecionada && this.funcaoSelecionada.parametros) {
        this.funcaoSelecionada.parametros.forEach((currentFieldSchema) => {
          let currentFieldControl = this.form
            .get("parametros")
            .get(currentFieldSchema.variavel);

          if (currentFieldControl) {
            if (
              currentFieldSchema.naoObrigatorioSe &&
              currentFieldSchema.naoObrigatorioSe.length
            ) {
              currentFieldSchema.naoObrigatorioSe.forEach((requiredFieldName) => {
                let requiredFieldControl = this.form
                  .get("parametros")
                  .get(requiredFieldName);

                if (
                  currentFieldControl &&
                  requiredFieldControl &&
                  currentFieldSchema.obrigatorio &&
                  this.formGroupIsEmpty(currentFieldControl) &&
                  this.formGroupIsEmpty(requiredFieldControl)
                ) {
                  if (currentFieldControl.get(currentFieldSchema.variavel)) {
                    currentFieldControl.get(currentFieldSchema.variavel).setValidators([Validators.required]);
                    currentFieldControl.get(currentFieldSchema.variavel).updateValueAndValidity();
                    currentFieldControl.updateValueAndValidity();
                  } else {
                    currentFieldControl.setValidators([Validators.required]);
                    currentFieldControl.updateValueAndValidity();
                  }
                }

                if (
                  requiredFieldControl &&
                  !this.formGroupIsEmpty(currentFieldControl)
                ) {
                  if (requiredFieldControl.get(requiredFieldName)) {
                    requiredFieldControl.get(requiredFieldName).setValidators([Validators.required]);
                    requiredFieldControl.get(requiredFieldName).updateValueAndValidity();
                    requiredFieldControl.updateValueAndValidity();
                  } else {
                    requiredFieldControl.clearValidators();
                    requiredFieldControl.updateValueAndValidity();
                  }
                }

                if (requiredFieldControl != null &&
                  currentFieldControl != null &&
                  currentFieldSchema.tipo === ParametroTipo.COMPOSTO &&
                  !this.formGroupIsEmpty(requiredFieldControl)) {
                  Object.keys((currentFieldControl as FormGroup).controls).forEach((control) => {
                    currentFieldControl.get(control).clearValidators()
                  })
                  currentFieldControl.updateValueAndValidity();
                }
                if (requiredFieldControl != null &&
                  currentFieldControl != null &&
                  currentFieldSchema.tipo === ParametroTipo.COMPOSTO &&
                  this.formGroupIsEmpty(requiredFieldControl)) {
                  Object.keys((currentFieldControl as FormGroup).controls).forEach((control) => {
                    currentFieldControl.get(control).setValidators(Validators.required)
                  })
                  currentFieldControl.updateValueAndValidity();
                }
              });
            }

            if (
              currentFieldSchema.obrigatorioSe &&
              currentFieldSchema.obrigatorioSe.length
            ) {
              currentFieldSchema.obrigatorioSe.forEach((requiredFieldName) => {
                let requiredFieldControl = this.form
                  .get("parametros")
                  .get(requiredFieldName);

                if (
                  requiredFieldControl &&
                  currentFieldSchema.obrigatorio &&
                  !this.formGroupIsEmpty(requiredFieldControl)
                ) {
                  if (currentFieldControl.get(currentFieldSchema.variavel)) {
                    currentFieldControl.get(currentFieldSchema.variavel).setValidators([Validators.required]);
                    currentFieldControl.get(currentFieldSchema.variavel).updateValueAndValidity();
                    currentFieldControl.updateValueAndValidity();
                  } else {
                    currentFieldControl.setValidators([Validators.required]);
                    currentFieldControl.updateValueAndValidity();
                  }
                }

                if (
                  requiredFieldControl &&
                  currentFieldControl &&
                  this.formGroupIsEmpty(requiredFieldControl)
                ) {
                  if (currentFieldControl.get(currentFieldSchema.variavel)) {
                    currentFieldControl.get(currentFieldSchema.variavel).clearValidators();
                    currentFieldControl.get(currentFieldSchema.variavel).updateValueAndValidity();
                    currentFieldControl.updateValueAndValidity();
                  } else {
                    currentFieldControl.clearValidators();
                    currentFieldControl.updateValueAndValidity();
                  }
                }
              });
            }
          }
        });
      }
      this.form.get("parametros").updateValueAndValidity();
    });
  }

  private buscarFuncoes(categoria) {
    this.funcaoService
      .buscarFuncoes(categoria)
      .subscribe(value => {
        this.funcoes = value;
        this.filteredFuncoes$.next(this.funcoes);
      });
  }

  private buscarFuncaoComposta() {
    this.funcaoService.buscarFuncoes("Regra composta").subscribe(
      res => {
        this.funcaoSelecionada = res[0];
        this.form.get("funcoes").setValue(res[0].nome);
      });
  }

  displayFn(funcao: FuncaoDTO): string {
    return funcao?.nome;
  }

  public gravarOuAlterar() {
    const regra = this.regraService.montarRegra(this.form, null, this.funcaoSelecionada);

    if (this.deveCriarRegra) {
      this.gravarRegra(regra);
    } else if (this.idRegra) {
      regra.id = this.idRegra;
      this.alterarRegra(regra);
    }
  }

  gravarRegra(regra: Regra) {
    this.subscriptions.add(
      this.regraService.gravarSimples(regra).subscribe(
        () => {
          this.toastService.textoLight("Regra cadastrada com sucesso!");
          this.limparForm();
        },
        (error: HttpErrorResponse) => {
          this.toastService.erro(error.error.message);
        }
      )
    );
  }

  alterarRegra(regra: Regra) {
    this.subscriptions.add(
      this.regraService.alterarRegraSimples(regra).subscribe(
        () => {
          this.toastService.textoLight("Regra alterada com sucesso.");
          this.limparForm();
          this.closeDialog.emit({});
        },
        (error) => {
          this.toastService.erro(error);
        }
      )
    );
  }

  public popularRegra(regraModel: Regra) {
    this.deveCriarRegra = false;
    const form = this.form;
    form.controls.nome.setValue(regraModel.nome);
    form.controls.utilizaCarteiraExplodida.setValue(regraModel.utilizaCarteiraExplodida);
    this.idRegra = regraModel.id;

    this.dataInicioSchema.value = this.regraService.transformDate(
      regraModel.inicioVigencia
    );
    this.dataFimSchema.value = this.regraService.transformDate(
      regraModel.fimVigencia
    );

    this.form.controls.dataInicioVigencia.setValue(this.dataInicioSchema.value);
    this.form.controls.dataFimVigencia.setValue(this.dataFimSchema.value);

    this.parametrosRegra = regraModel.parametros;
    this.loadFuncaoSelecionada(regraModel, form);
  }

  private loadFuncaoSelecionada(regraModel: Regra, form: FormGroup) {
    this.subscriptions.add(
      this.funcaoService.buscarFuncao(regraModel.funcao).subscribe((funcao) => {
        this.funcaoSelecionada = funcao;

        form.controls.categoria.setValue(this.funcaoSelecionada.categoria);

        this.buscarFuncoes(this.funcaoSelecionada.categoria);
        form.controls.funcoes.setValue(this.funcaoSelecionada);
      })
    );
  }

  set isDiolog(value: boolean) {
    this._isDiolog = value;
  }

  compareFunctionObjects(object1: any, object2: any) {
    return object1 && object2 && object1.nome === object2.nome;
  }

  compareEnumCategoria(object1: any, object2: any) {
    return object1 === object2;
  }

  private _filtrar(value: string) {
    this.filteredFuncoes = this.filteredFuncoes$.value.filter(v => v.nome.toLocaleLowerCase().includes(value.toLocaleLowerCase()))
  }
}
